import React from "react";
import { useTranslation } from "react-i18next";
import { Item } from "../../../../components/Item";

export const QuoteBody = ({ items, hasAnnualRate = true }) => {
  const [t] = useTranslation();

  return (
    <div
      className={`quote-table__body ${
        hasAnnualRate ? "" : "quote-table__body--eurobonds"
      }`}
    >
      {items.map(
        ({
          isin,
          title,
          maturity_date,
          // price_update_date,
          annual_rate,
          price,
        }) => (
          <div className="quote-table__body-row" key={isin}>
            <Item className="quote-table__body-item">{title}</Item>
            <Item className="quote-table__body-item">{isin}</Item>
            <Item className="quote-table__body-item">{maturity_date}</Item>
            {hasAnnualRate && (
              <Item className="quote-table__body-item">{annual_rate}%</Item>
            )}
            <Item className="quote-table__body-item">
              {price} {t("grn")}
            </Item>
            {/* <Item className="quote-table__body-item">
              {price_update_date ? price_update_date : "—"}
            </Item> */}
          </div>
        )
      )}
    </div>
  );
};
